import {VersandstatusHistorieBelegState} from './versandstatus-historie-beleg.state';


export interface VersandstatusHistoryState {
  byBelegId: Record<string, VersandstatusHistorieBelegState>;
}


export const initialVersandstatusHistoryState: VersandstatusHistoryState = {
  byBelegId: {},
};
